<template>
  <page-view title>
    <div slot="headerContent"></div>
    <div :style="{marginBottom:'10px'}">
      <demo-video-alert name="ChaJianSheZhe"></demo-video-alert>
    </div>
    <a-spin :spinning="PullLoading">
      <a-card title="海报" :bordered="false">
        <template slot="extra">
          <search-robot-input
            class="search-robot-input"
            :showInfo="false"
            :selectFirst="false"
            primaryBtnText="拉取配置"
            @changeRobotId="onChangeRobotId"
          ></search-robot-input>
        </template>
        <a-alert
          v-if="!robotid"
          :style="{margin: '10px 0 20px 0'}"
          message="重要提醒"
          description="当前显示的系统默认数据，如需加载指定机器人数据请在右上角输入框进行拉取配置操作。"
          type="warning"
          show-icon
        />
        <a-alert v-if="robotid" :style="{margin: '10px 0 20px 0'}" message="已经拉取机器人配置" type="success" show-icon />
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item
            label="海报图片"
            :label-col="{xs: { span: 24 },sm: { span: 4 }}"
            :wrapper-col="{xs: { span: 24 },sm: { span: 10 }}"
          >
            <a-upload
              action="https://upload-z2.qiniup.com"
              listType="picture-card"
              :data="{'token': UploadToken}"
              :fileList="posterFileList"
              :beforeUpload="beforeUpload"
              @preview="handlePreview"
              @change="handlePosterListChange"
            >
              <div v-if="posterFileList.length < 1">
                <a-icon type="plus" />
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancel"
              :closable="false"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="选择机器人"
            :label-col="{xs: { span: 24 },sm: { span: 4 }}"
            :wrapper-col="{xs: { span: 24 },sm: { span: 10 }}"
          >
            <robot-multiple v-decorator="['robotids',{rules: [{required: true, message: '必填项'}]}]"></robot-multiple>
          </a-form-item>
          <a-form-item :wrapper-col="{xs: { span: 12, offset: 0 },sm:  { span: 12, offset: 4 }}">
            <a-button htmlType="submit" type="primary">推送</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-spin>
  </page-view>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
import SearchRobotInput from '@/views/components/SearchRobotInput'
import TriggerTags from '@/views/components/TriggerTags'
import RobotMultiple from '@/views/components/RobotMultiple'
import MoneySlide from '@/views/components/MoneySlide'
import DeviceApi from '@/api/device'
import ProgramApi from '@/api/program'
import { PageView } from '@/layouts'
import { mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
export default {
  name: 'PluginPoster',
  data() {
    return {
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          Object.assign(this.formData, values)
        }
      }),
      tags: [],
      PullLoading: false,
      formData: {},
      previewVisible: false,
      previewImage: '',
      posterFileList: [],
      UploadToken: '',
      robotid: null
    }
  },
  components: {
    PageView,
    SearchRobotInput,
    TriggerTags,
    MoneySlide,
    RobotMultiple,
    DemoVideoAlert
  },
  created() {
    // this.getData()
  },
  mounted() {},
  methods: {
    ...mapActions(['BatchpushTask', 'TaskDrawerSwitch', 'demoSetVideo']),
    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const poster_url = this.getQiniuUrl(this.posterFileList[0])
          values.user_poster_url = poster_url
          this.BatchpushTask({
            robotids: values.robotids,
            descs: '海报配置',
            apiFun: sub_id => {
              return DeviceApi.savePosterSettingsInfo(Object.assign({ sub_id: sub_id }, values))
            }
          })
          this.TaskDrawerSwitch({ status: true })
          this.form.resetFields('robotids')
        }
      })
    },
    // 选择机器人
    onChangeRobotId(robotid) {
      this.robotid = robotid
      this.getData(robotid)
    },
    // 获取配置信息
    getData(robotid) {
      this.PullLoading = true
      DeviceApi.getPosterSettingInfo({ sub_id: robotid })
        .then(res => {
          if (res.code === 1) {
            this.posterFileList = [
              {
                uid: 1,
                name: 'asdasdsa',
                status: 'done',
                url: res.data.user_poster_url
              }
            ]
            this.form.setFieldsValue({})
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.PullLoading = false
        })
    },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handlePosterListChange({ fileList }) {
      this.posterFileList = fileList
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then(response => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(() => {
                resolve()
              }, 100);
              
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getQiniuUrl(file) {
      if (!file) {
        return ''
      } else if (file.url) {
        return file.url
      } else if (file.response) {
        const data = file.response
        return `http://${data.domain}/${data.fkey}`
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
/deep/ .ant-card-extra {
  padding: 0;
}
</style>

